import { CheckCircleOutlined, EyeOutlined } from "@ant-design/icons";
import { Button } from "antd";

// Common columns shared across all types
const commonColumns = (navigateTo, showModal) => [
  {
    title: "Nom",
    dataIndex: "firstname",
    key: "firstname",
  },
  {
    title: "Prénom",
    dataIndex: "lastname",
    key: "lastname",
  },
  // --- DÉBUT AJOUT ---
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
    render: (code) => <>{code || ''}</>,
  },
  // --- FIN AJOUT ---
  {
    title: "Gouvernorat",
    dataIndex: "government",
    key: "gouvernorat",
    render: (data) => <>{data?.name}</>,
  },
  {
    title: "Région",
    dataIndex: "region",
    key: "region",
    render: (data) => <>{data?.name}</>,
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "Téléphone",
    dataIndex: "phoneNumber",
    key: "phone",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  // The "Action" column will be added later
];

// Function to get columns based on type
export const getColumnsByType = (type, navigateTo, showModal) => {
  let specificColumns = [];
  type.forEach((t) => {
    switch (t) {
      case 1:
        specificColumns = [
          ...specificColumns,
          {
            title: "Spécialités",
            dataIndex: "doctor",
            key: "speciality",
            render: (data) => <>{data?.specialty?.abreviation}</>,
          },
          {
            title: "Potential",
            dataIndex: "potential",
            key: "potential",
          },
          {
            title: "Type",
            dataIndex: "doctor",
            key: "doctorType",
            render: (data) => <>{data?.doctorType === 1 ? "Hospitalier" : "Privé"}</>,
          }
        ];
        break;
      case 2:
        specificColumns = [
          ...specificColumns,
          {
            title: "Pharmacie",
            dataIndex: "pharmacien",
            key: "pharmacy",
            render: (data) => <>{data?.pharmacyName}</>,
          }
        ];
        break;
      case 3:
        specificColumns = [
          ...specificColumns,
          {
            title: "Dépot",
            dataIndex: "wholesaler",
            key: "wholesaler",
            render: (data) => <>{data?.companyName}</>,
          }
        ];
        break;
      default:
        break;
    }
  });

  // Combine specific columns with common columns, and add "Action" column last
  return [
    ...commonColumns(navigateTo, showModal),
    ...specificColumns,
    {
      title: "Action",
      key: "action",
      render: (record) => {
        let editPath;
        switch (type) {
          case 1:
            editPath = `/edit/médecin/${record.id}`;
            break;
          case 2:
            editPath = `/edit/pharmacie/${record.id}`;
            break;
          case 3:
            editPath = `/edit/grossiste/${record.id}`;
            break;
          default:
            editPath = `/edit/${record.type}/${record.id}`;
            break;
        }
        return (
          <>
            <Button
              type="link"
              className="darkbtn"
              onClick={() => navigateTo(editPath)}
            >
              <EyeOutlined /> Voir
            </Button>
            <Button
              type="link"
              style={{ color: "green" }}
              onClick={() => showModal(record.id)}
            >
              <CheckCircleOutlined /> Assigner
            </Button>
          </>
        );
      },
    },
  ];
};
